import * as angular from "angular";
import {PredefinedSkillType} from "../types/predefined-skill.type";

angular
  .module('bringoz.admin.skills')
  .filter('skillDescription', skillDescription);

function skillDescription($translate) {
  return function skillDescriptionFunction(description) {

    if (!description) {
      return;
    }

    if (description === PredefinedSkillType.Delivery ||
      description === PredefinedSkillType.Merchandise ||
      description === PredefinedSkillType.Order) {
      return $translate.instant(`SKILLS_DESCRIPTION.${description}`);
    } else {
      return description;
    }

  }
}
